export const es = {
  properties: {
    title: 'Propiedades',
    position: 'Posición',
    x: 'Posición X',
    y: 'Posición Y',
    rotation: 'Rotación',
    color: 'Color',
    number: 'Número',
    name: 'Nombre',
    team: 'Equipo',
    otherNumber: 'Otro número...',
    size: {
      title: 'Tamaño',
      small: 'Pequeño',
      medium: 'Mediano',
      large: 'Grande'
    },
    visibility: {
      show: 'Mostrar',
      hide: 'Ocultar',
      toggleAll: 'Todos'
    },
    actions: {
      applyToAll: 'Aplicar a todos',
      delete: 'Eliminar',
      lockPosition: 'Bloquear posición'
    }
  },
  toolbar: {
    newPage: 'Nueva página',
    open: 'Cargar',
    save: 'Guardar',
    addPlayer: 'Añadir jugador',
    addBall: 'Añadir balón',
    addZone: 'Añadir zona',
    addArrow: 'Añadir flecha',
    editField: 'Editar campo',
    exportVideo: 'Exportar a vídeo',
    exportImage: 'Exportar a PNG',
    backgroundColor: 'Color de fondo',
    changeLanguage: 'Cambiar idioma',
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión'
  },
  panels: {
    pitch: {
      title: 'Configuración del campo',
      type: {
        title: 'Tipo de campo',
        label: 'Tipo de campo',
        full: 'Campo completo',
        half: 'Medio campo'
      },
      side: {
        label: 'Lado del campo',
        left: 'Izquierdo',
        right: 'Derecho'
      },
      display: {
        title: 'Opciones de visualización',
        medianLine: 'Línea media',
        centralCircle: 'Círculo central',
        centralPoint: 'Punto central',
        penaltyArea: 'Área de penalti',
        penaltyAreaArcs: 'Arcos del área',
        penaltyPoints: 'Puntos de penalti',
        goalArea: 'Área de portería',
        goals: 'Porterías',
        cornerArcs: 'Arcos de córner',
        halfSpaces: 'Medios Espacios'
      }
    },
    zone: {
      title: 'Zona',
      opacity: 'Opacidad',
      fill: 'Color de relleno',
      borderStyle: 'Estilo de borde',
      strokeWidth: 'Ancho de borde',
      strokeOpacity: 'Opacidad de borde',
      draggable: 'Arrastrable',
      lock: 'Bloquear zona',
      strokeColor: 'Color del trazo',
      fillColor: 'Color de relleno',
      fillOpacity: 'Opacidad del relleno',
      dashArray: 'Estilo de línea',
      solid: 'Sólida',
      dashed: 'Discontinua',
      dotted: 'Punteada',
      lockPosition: 'Bloquear posición',
      delete: 'Eliminar zona'
    },
    player: {
      title: 'Jugador'
    },
    ball: {
      title: 'Balón',
      size: 'Tamaño',
      color: 'Color',
      strokeColor: 'Color del borde',
      hideStroke: 'Ocultar borde'
    },
    arrow: {
      title: 'Flecha',
      strokeWidth: 'Ancho del trazo',
      strokeOpacity: 'Opacidad del trazo',
      borderStyle: 'Estilo del borde',
      color: 'Color',
      styles: {
        solid: 'Sólido',
        dashed: 'Discontinuo',
        dotted: 'Punteado'
      }
    },
    training: {
      title: 'Equipamiento',
      items: {
        cone: 'Cono',
        mannequin: 'Maniquí',
        goal: 'Portería',
        ladder: 'Escalera',
        hoop: 'Aro',
        disc: 'Disco',
        hurdle: 'Valla',
        pole: 'Palo',
        miniGoal: 'Mini portería'
      },
      step: 'Paso',
      steps: {
        one: 'Etapa 1',
        two: 'Etapa 2',
        three: 'Etapa 3',
        four: 'Etapa 4',
        five: 'Etapa 5'
      }
    },
    trainingItem: {
      title: 'Editar',
      color: 'Color',
      size: 'Tamaño',
      rotation: 'Rotación',
      fineRotation: 'Rotación fina'
    }
  },
  landing: {
    hero: {
      title: {
        part1: "La herramienta más simple",
        part2: "y rápida",
        part3: "para generar videos de"
      },
      words: {
        videos: "RONDOS",
        sequences: "SECUENCIAS",
        compositions: "COMPOSICIONES",
        exercises: "EJERCICIOS",
        cpa: "JUGADAS BALON PARADO",
        games: "JUEGOS"
      },
      cta: "Empezar gratis",
      login: "Iniciar sesión"
    },
    sections: {
      video: {
        title: "Ver TacticaFoot en acción"
      },
      exercises: {
        title: "Crea tus ejercicios",
        cta: "Descubrir"
      },
      sessions: {
        title: "Organiza tus sesiones",
        cta: "Saber más"
      },
      present: {
        title: "Presenta",
        cta: "Probar ahora"
      },
      share: {
        title: "Compartir",
        cta: "Unirse",
        login: "Iniciar sesión"
      },
      pricing: {
        title: "Nuestros Precios",
        regularPrice: "65€ / año",
        specialOffer: "Oferta Especial",
        specialPrice: "37€ / año",
        payButton: "Suscribirse"
      },
      why: {
        title: '¿Por qué TACTICAFOOT?',
        features: {
          simple: {
            title: 'Simple',
            description: 'TacticaFoot es tan simple que ya sabes cómo usarlo'
          },
          sync: {
            title: 'Sincronizado',
            description: 'Accede a tus tácticas en todos tus dispositivos'
          },
          rapide: {
            title: 'Rápido',
            description: 'La aplicación más rápida para generar videos o imágenes'
          },
          puissant: {
            title: 'Potente',
            description: 'Dale superpoderes a tu equipo'
          },
          accessible: {
            title: 'Accesible',
            description: 'TacticaFoot está disponible en todas partes, sin instalación'
          },
          secure: {
            title: 'Seguro',
            description: 'Tus datos están protegidos y respaldados'
          },
          intuitif: {
            title: 'Intuitivo',
            description: 'Una interfaz fluida diseñada para entrenadores'
          },
          evolutif: {
            title: 'Evolutivo',
            description: 'Mejoras todas las semanas'
          },
          collab: {
            title: 'Colaborativo',
            description: 'Envía videos e imágenes a tus equipos o personal'
          }
        }
      }
    },
    nav: {
      discover: 'Descubrir',
      pricing: 'Precios',
      contact: 'Contacto'
    }
  },
  signup: {
    title: {
      step1: 'Crear cuenta',
      step2: 'Finalizar registro'
    },
    fields: {
      email: 'Email',
      firstName: 'Nombre',
      lastName: 'Apellido',
      club: 'Club',
      phone: 'Teléfono',
      password: 'Contraseña',
      marketingSource: '¿Cómo nos conociste?'
    },
    country: 'País',
    language: 'Idioma',
    buttons: {
      validate: 'Validar',
      signup: 'Registrarse'
    },
    consent: 'Acepto recibir novedades de Tacticafoot.',
    success: {
      title: '¡Registro exitoso!',
      message: 'Se ha enviado un correo electrónico de confirmación. Por favor, revise su bandeja de entrada.',
      cta: 'Acceder al tutorial'
    },
    errors: {
      required: 'Este campo es obligatorio',
      consent: 'Debes aceptar recibir novedades',
      emailInUse: 'Ya existe una cuenta con esta dirección de correo.',
      registration: 'Error durante el registro'
    }
  },
  login: {
    title: 'Iniciar sesión',
    fields: {
      email: 'Email',
      password: 'Contraseña',
      showPassword: 'Mostrar contraseña',
      hidePassword: 'Ocultar contraseña',
      rememberMe: 'Recuérdame'
    },
    buttons: {
      login: 'Iniciar sesión',
      forgotPassword: '¿Olvidaste tu contraseña?',
      signup: 'Crear cuenta'
    },
    errors: {
      invalidEmail: 'Dirección de email inválida',
      userDisabled: 'Esta cuenta ha sido desactivada',
      userNotFound: 'No existe una cuenta con esta dirección de email',
      wrongPassword: 'Contraseña incorrecta',
      default: 'Ocurrió un error durante el inicio de sesión'
    },
    resetPassword: {
      title: 'Restablecer contraseña',
      description: 'Ingresa tu dirección de email y te enviaremos un enlace para restablecer tu contraseña.',
      button: 'Enviar enlace',
      cancel: 'Cancelar',
      success: '¡Email enviado! Revisa tu bandeja de entrada.',
      error: 'Error al enviar el email. Verifica tu dirección de email.'
    }
  },
  footer: {
    rights: 'Todos los derechos reservados',
    contact: 'Contacto',
    legal: 'Aviso legal',
    otherTools: {
      title: 'Otras herramientas',
      features: 'Gestión de equipos, Biblioteca de ejercicios, Gestión de partidos y entrenamientos, Convocatorias, Control de asistencia'
    }
  }
};
